export const SPECIALIZED = [
    { path: 'homedevice', text: 'At-Home Laser Hair Removal' },
    { path: 'active-lifestyle', text: 'Laser Hair Removal For Active Lifestyle' },
    {
        path: 'inclusive-clientele/amputees',
        text: 'Laser Hair Removal For Amputees',
    },
    { path: 'bodybuilding', text: 'Laser Hair Removal For Bodybuilders' },
    { path: 'areas/darkskin/', text: 'Laser Hair Removal For Brown Skin' },
    { path: 'folliculitis', text: 'Laser Hair Removal For Folliculitis' },
    {
        path: 'conditions/hs',
        text: 'Laser Hair Removal For Hidradenitis Suppurativa',
    },
    { path: 'pcos', text: 'Laser Hair Removal For PCOS' },
    {
        path: 'conditions/pilonidal-cysts',
        text: 'Laser Hair Removal For Pilonidal Cysts',
    },
    { path: 'trans', text: 'Laser Hair Removal For Transgender Clients' },
];

export const ABOUT_MILAN_ITEMS = [
    { path: 'company/about-us', text: 'About Us' },
    { path: 'company/reviews', text: 'Reviews' },
    { path: 'blog', text: 'Blog' },
    { path: 'careers', text: 'Careers' },
    { path: 'press', text: 'Press' },
    { path: 'company/contact-us', text: 'Contact Us' },
    { path: 'privacy', text: 'Privacy Policy' },
    { path: 'terms', text: 'Terms and Conditions' },
];
